import React, { useEffect, useState } from "react";
import { useNavigate, Routes, Route } from "react-router-dom";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button } from "react-bootstrap";
import { supabase } from "../supabaseClient";
import Sidebar from '../components/Sidebar';
import Dashboard from './Dashboard';
import BusinessInfo from './BusinessInfo';
import Bookings from './Bookings';
import Withdrawals from './Withdrawals';
import Header from '../components/Header';
import MobileNav from "../components/MobileNav";

export const Home = () => {
  const [user, setUser] = useState();
  const [teacherAuth, setTeacherAuth] = useState([]);
  const [activeLink, setActiveLink] = useState('dashboard');
  const navigate = useNavigate();

  useEffect(() => {
    const getUserData = async () => {
      await supabase.auth.getUser().then((value) => {
        if (value.data?.user) {
          setUser(value.data.user);
        }
      });
    };

    const fetchUserAuth = async () => {
      try {
        const { data, error } = await supabase
          .from('admins') // Assuming 'admins' is the table name
          .select('*');
        if (error) throw error;
        setTeacherAuth(data); // Set userauth from Supabase
      } catch (error) {
        console.error('Error fetching user auth:', error);
      }
    };

    getUserData();
    fetchUserAuth();
  }, []);

  const handleLinkClick = (link) => {
    setActiveLink(link);
  };

  const signOutUser = async () => {
    await supabase.auth.signOut();
    navigate('/login');
  };

  return (
    <div>
      {user && teacherAuth.length > 0 && teacherAuth.some((auth) => auth.email === user.user_metadata.email) ? (
        <div style={{ width: '100%' }}>
          <ToastContainer />
          <Header />
          <div style={{ display: 'flex', width: '100%' }}>
            <Sidebar activeLink={activeLink} handleLinkClick={handleLinkClick} signOutUser={signOutUser} />
            <MobileNav activeLink={activeLink} handleLinkClick={handleLinkClick} signOutUser={signOutUser} />
            
          <div style={{ flex: 1 }}>
            <div style={{ padding: '20px' }}>
              <Routes>
                <Route path="/home" element={<Dashboard />} />
                <Route path="/businessInfo" element={<BusinessInfo />} />
                <Route path="/bookings" element={<Bookings />} />
                <Route path="/withdraw" element={<Withdrawals />} />
              </Routes>
            </div>
            </div>
            </div>
        </div>
      ) : (
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#f0f2f5',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              alignItems: 'center',
              width: '60%',
              padding: '40px',
              backgroundColor: '#fff',
              borderRadius: '10px',
              boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
              textAlign: 'center',
            }}
          >
            <h1 style={{ marginBottom: '20px', color: '#333' }}>
              User not authorised
            </h1>
            <p style={{ marginBottom: '40px', color: 'red' }}>
              Please login with proper credentials or check your internet connection.
            </p>
            <Button
              onClick={() => {
                navigate('/login');
              }}
              className="btn btn-primary"
              style={{
                padding: '10px 20px',
                fontSize: '16px',
                borderRadius: '5px',
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
              }}
            >
              Go to Login
            </Button>
          </div>
        </div>
      )}
    </div>
  )
}
